











































import { Component, Prop } from "vue-property-decorator";

import JConfTableS01 from "@share/common/tables/j-conf-table/simple/JConfTable-S01.vue";
import UserBlock from "@share/common/user/UserBlock.vue";
import TableLimitMessage from "@share/participants-import/components/table-limit-message/TableLimitMessage.vue";
import RoundCheckSvg from "../../../../../assets/svg/round-check.svg";
import DownloadSvg from "../../../../../assets/svg/download.svg";

import { UserProfile } from "@api/models/UserProfile";
import { HeaderSetting, TableSettings } from "@share/common/tables/j-conf-table/types";
import { ProfileField } from "../../../../../types/ProfileField";
import ImportStep from "../ImportStep.vue";

import { AppliedDataCount } from "@share/participants-import/types";
import { getHeaderSettingsByFields } from "@share/participants-import/helpers/headerSettings";

@Component({ components: { JConfTableS01, UserBlock, TableLimitMessage, RoundCheckSvg, DownloadSvg } })

export default class Step4Result extends ImportStep {
    @Prop() profiles: UserProfile[];
    @Prop() resultAdditionalFields: ProfileField[];
    @Prop() fileLink: string;
    @Prop() resultCount: AppliedDataCount;
    @Prop() limit: number;

    tableSettings: TableSettings = {
        minRowHeight: 76
    }

    get additionFields() {
        return this.resultAdditionalFields.map(field => field.name)
    }

    get headerSettings(): HeaderSetting[] {
        const language = this.$store.state.session?.language ?? 'en';

        let fields: ProfileField[] = this.resultAdditionalFields;

        const result = getHeaderSettingsByFields(fields, language);

        const fullNameCol: HeaderSetting = {
            title: this.$t("participants.fullName").toString(),
            name: "fullName"
        }

        const codeCol: HeaderSetting = {
            title: this.$t("participants.import.accessCode").toString(),
            name: "code"
        }

        return [fullNameCol, ...result, codeCol]
    }

    get createdCountString() {
        return `${this.$t("participants.import.result.created")}: ${this.resultCount.created}`;
    }

    get updatedCountString() {
        return `${this.$t("participants.import.result.updated")}: ${this.resultCount.updated}`;
    }

    //move to common function
    getCaption(field: ProfileField, language: string) {
        return field && field.title && field.title[language]
            ? field.title[language]
            : this.$t('settings.' + field.name.toLowerCase()).toString();
    }
}

